import ConfigContext from "./ConfigContext.tsx";
import { ReactNode } from "react";
import ScriptHelper from "@/utils/scriptHelper.tsx";
import DataHelper from "@/utils/dataHelper.tsx";

type Props = {
  children: ReactNode;
}

const ConfigProvider = ({ children }: Props) => {
  const scriptElement = ScriptHelper.getScriptElement();
  const domainId = parseInt(scriptElement?.getAttribute(`data-ws-domain-id`) || ``);
  const publicKey = scriptElement?.getAttribute(`data-ws-public-key`) || ``;
  const language = scriptElement?.getAttribute(`data-ws-language`) || document.documentElement.lang;
  const currency = scriptElement?.getAttribute(`data-ws-currency`) || `EUR`;
  const environment = scriptElement?.getAttribute(`data-ws-environment`) || `production`;

  const backendHost = DataHelper.getBackendUrl(language, environment);

  const config = {
    backendHost: backendHost,
    domainId: domainId,
    publicKey: publicKey,
    language: language,
    currency: currency,
    debug: import.meta.env.VITE_DEBUG,
  }

  return (
    <ConfigContext.Provider value={ config }>
      { children }
    </ConfigContext.Provider>
  )
}

export default ConfigProvider;
